import {Button} from '@wandb/components';
import React from 'react';

import {usePart, useViewAction} from '../../../state/views/hooks';
import * as PanelBankConfigActions from '../../../state/views/panelBankConfig/actions';
import {DD_PRIVACY_ALLOW} from '../../../util/datadog/privacy';
import {useWorkspaceRefsContext} from '../../Workspace/WorkspaceRefsContext';
import {usePanelsQuickAddContext} from '../../WorkspaceDrawer/PanelsQuickAdd/PanelsQuickAddContext';

export const AddSectionButton = () => {
  const {closeQuickAdd} = usePanelsQuickAddContext();
  const {panelBankConfigRef} = useWorkspaceRefsContext();
  const panelBankConfigPart = usePart(panelBankConfigRef);
  const addSection = useViewAction(
    panelBankConfigRef,
    PanelBankConfigActions.addSection
  );
  const {sectionRefs} = panelBankConfigPart;
  const hiddenSectionRef = sectionRefs[sectionRefs.length - 1];
  // ^ NOTE: this assumes Hidden Panels is the last section

  return (
    <Button
      variant="secondary"
      startIcon="add-new"
      data-dd-action-name="Add section"
      data-dd-privacy={DD_PRIVACY_ALLOW}
      onPress={() => {
        closeQuickAdd();
        addSection(hiddenSectionRef);
      }}>
      Add section
    </Button>
  );
};
